import React, { useState, useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";

import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import TitreTypography from "../../composant/Typography/TitreTypography";
import SousTitreTypography from "../../composant/Typography/SousTitreTypography";
import { Link } from "react-router-dom";
import { stylebox } from "./home";
import BottomBar from "../../composant/navbar/ButtomBar";
import { ImportButton } from "../../composant/UploadFiles";
import BarUploadProduct from "../../composant/bar/BarUploadProduct";
import { ReactComponent as IconDemention } from "../../image/icons/Dimensions.svg";
import { ReactComponent as IconImage } from "../../image/icons/IconImage.svg";
import { ReactComponent as IconClock } from "../../image/icons/clock.svg";
import heic2any from "heic2any";
import { dbUploadImage } from "../../service/UploadServices";
import ResizeAndCompressWithPica from "../../service/compresse";
import { BackLoadingSimple } from "../../composant/loading/backLoading";
import { useProductResolution } from "../../hooks/useProductResolution";
import Page404 from "./NotFound";
import {
  addUploadBreadcrumb,
  captureImageUploadError,
  isHeic,
  newCorrelationId,
  reportEvent,
} from "../../service/monitoring";
function InformationProduct() {
  const { type } = useParams();
  const { product: dataProduit, status: productStatus } = useProductResolution(type);
  const { Produits } = useSelector((state) => state.dataApp);
  const [loading, setLoading] = useState(false);
  const Navigate = useNavigate();
  const fileInputRef = useRef(null);
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  async function AddImage(e) {
    setLoading(true);
    const acceptedFiles = Array.from(e.target.files || []);
    const correlationId = newCorrelationId();
    const product = { id: dataProduit.id, type };
    addUploadBreadcrumb("image_selected", { product_type: type, file_count: acceptedFiles.length });

    const results = await Promise.all(
      acceptedFiles.map(async (file, originalIndex) => {
        let stage = "conversion";
        try {
          addUploadBreadcrumb("image_metadata_read", {
            file_index: originalIndex,
            name: file.name,
            size: file.size,
            mime_type: file.type,
          });

          let convertedFile = file;
          if (isHeic(file)) {
            addUploadBreadcrumb("heic_conversion_started", { file_index: originalIndex });
            const blob = await heic2any({
              blob: file,
              toType: "image/jpeg",
              quality: 0.8,
            });
            convertedFile = new File(
              [blob],
              file.name.replace(/\.heic$/i, ".jpg"),
              {
                type: "image/jpeg",
              }
            );
            addUploadBreadcrumb("heic_conversion_success", {
              file_index: originalIndex,
              output_bytes: convertedFile.size,
            });
          }

          stage = "compression";
          addUploadBreadcrumb("compression_started", { file_index: originalIndex });
          const compressedFile = await ResizeAndCompressWithPica(
            convertedFile,
            1920, // أقصى عرض
            0.8 // جودة الضغط
          );
          addUploadBreadcrumb("compression_success", {
            file_index: originalIndex,
            output_bytes: compressedFile.size,
          });

          return { status: "fulfilled", originalFile: file, processedFile: compressedFile, originalIndex };
        } catch (err) {
          addUploadBreadcrumb(`${stage}_failed`, { file_index: originalIndex });
          console.error("Error during conversion or compression:", err);
          await captureImageUploadError({
            error: err,
            stage: `image_${stage}`,
            originalFile: file,
            product,
            correlationId,
            extra: { file_index: originalIndex, product_type: type },
          });
          return { status: "rejected", originalFile: file, originalIndex, error: err };
        }
      })
    );

    try {
      const succeeded = results.filter((r) => r.status === "fulfilled");
      const failed = results.filter((r) => r.status === "rejected");

      const newImages = succeeded.map(({ originalFile, processedFile }) => ({
        name: originalFile.name,
        file: processedFile,
        idProduit: dataProduit.id,
        count: 1,
      }));

      if (newImages.length > 0) {
        addUploadBreadcrumb("upload_prepared", { product_type: type, count: newImages.length });
        await dbUploadImage(type, newImages);
      }

      reportEvent("image_import.completed", {
        product_type: type,
        file_count: acceptedFiles.length,
        saved_count: newImages.length,
        failed_count: failed.length,
      });

      if (failed.length > 0) {
        alert(`Some images failed to upload`);
      }
    } catch (error) {
      await captureImageUploadError({
        error,
        stage: "image_storage",
        product,
        correlationId,
        extra: { product_type: type },
      });
      console.error("Unexpected error during image upload:", error);
      alert("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
      addUploadBreadcrumb("navigation_started", { product_type: type });
      Navigate(`/produit/${type}`);
    }
  }

  if (productStatus === "loading") {
    return <BackLoadingSimple open />;
  }
  if (productStatus === "not_found") {
    return <Page404 />;
  }

  const otherProducts = Produits.filter((p) => p.NomProduit !== dataProduit.NomProduit);
  return (
    <Box sx={{ background: "#f7f7f7", minHeight: "100vh" }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: 220,

          overflow: "hidden",
          mb: 2,
        }}
      >
        <Box
          component="img"
          src={dataProduit.ImageUpload}
          alt="Photos"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            padding: 1,
            zIndex: 10,
          }}
        >
          <BarUploadProduct
            beforeOnClik={() => {
              Navigate("/");
            }}
            LovelyIcon={false}
          />
        </Box>
      </Box>
      <Box
        sx={{
          borderRadius: "24px",
          position: "relative",
          zIndex: 3,
          marginTop: "-40px",
          background: "#f7f7f7",
          paddingTop: "10px",
        }}
      >
        <Box
          sx={{
            background: "#23243a",
            borderRadius: "18px",
            p: 2.5,
            mx: 2,
            color: "#fff",
            mb: 2,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            position: "relative",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Urbanist, sans-serif",
                  fontWeight: 900,
                  textTransform: "capitalize",
                  letterSpacing: "0.5px",
                }}
              >
                Tirage {dataProduit.NomProduit}
              </Typography>
            </Grid>
            <Grid item>
              <Box
                sx={{
                  width: "83px",
                  height: "30px",
                  background: "#e63e57",
                  color: "#fff",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  px: "24px", // padding-left and padding-right
                  py: "16px", // padding-top and padding-bottom
                  opacity: 1,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Montserrat",
                    fontWeight: 700,
                    fontSize: "15px",
                    lineHeight: "20px",
                    verticalAlign: "middle",
                  }}
                >
                  {dataProduit.prix}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Montserrat",
                    fontWeight: 700,
                    fontSize: "8.76px",
                    lineHeight: "16.42px",
                    verticalAlign: "middle",
                  }}
                >
                  Dhs
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <SousTitreTypography
            //  sx={{ mt: 1, mb: 2, fontSize: "0.95rem", opacity: 0.9 }}
            sx={{
              color: "#fff",
              opacity: 0.7,
              fontSize: { xs: "70%", md: "100%" },
            }}
          >
            {dataProduit.descriptif}
          </SousTitreTypography>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              {" "}
              <Typography
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 600,
                  fontStyle: "normal",
                  fontSize: "11px",
                  lineHeight: "22px",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  color: "#BCBCC2",
                }}
              >
                Nombre de photos
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 600,
                  fontStyle: "normal",
                  fontSize: "11px",
                  lineHeight: "22px",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  color: "#BCBCC2",
                }}
              >
                Dimension
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 600,
                  fontStyle: "normal",
                  fontSize: "11px",
                  lineHeight: "22px",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  color: "#BCBCC2",
                }}
              >
                Livraison
              </Typography>
            </Grid>

            {/* Colonne 1 */}
            <Grid item xs={4}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  background: "#fff",
                  color: "black",
                  borderRadius: "16px",
                  gap: 1,
                  px: 1,
                  py: 0.5,
                }}
              >
                <IconImage style={{ width: 16, height: 16 }} />
                <Typography
                  sx={{
                    fontFamily: "Mulish, sans-serif",
                    fontWeight: 600,
                    fontSize: "11px",
                    lineHeight: "14px",
                    color: "#32324D",
                  }}
                >
                  1 - 100 photos
                </Typography>
              </Box>
            </Grid>

            {/* Colonne 2 */}
            <Grid item xs={4}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  background: "#fff",
                  color: "black",
                  borderRadius: "16px",
                  px: 2,
                  py: 0.5,
                }}
              >
                <IconDemention style={{ width: 20, height: 20 }} />
                <Typography
                  sx={{
                    fontFamily: "Mulish, sans-serif",
                    fontWeight: 600,
                    fontSize: "11px",
                    lineHeight: "14px",
                    color: "#32324D",
                  }}
                >
                  {dataProduit.dementionDesc}
                </Typography>
              </Box>
            </Grid>

            {/* Colonne 3 */}
            <Grid item xs={4}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  background: "#fff",
                  color: "black",
                  borderRadius: "16px",
                  px: 2,
                  py: 0.5,
                }}
              >
                <IconClock style={{ width: 20, height: 20 }} />
                <Typography
                  sx={{
                    fontFamily: "Mulish, sans-serif",
                    fontWeight: 600,
                    fontSize: "11px",
                    lineHeight: "14px",
                    color: "#32324D",
                  }}
                >
                  Surplace
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box sx={{ mx: 2, mb: 4, textAlign: "center" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ImportButton fullWidth onClick={handleButtonClick}>
              Sélectionner Mes Photos
            </ImportButton>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "50px" }}>
            <TitreTypography>Vous voulez voir autre chose ?</TitreTypography>
          </Grid>
          <Grid item xs={12}>
            <SousTitreTypography>
              Tout ce que vous cherchez est là !
            </SousTitreTypography>
          </Grid>

          {otherProducts.map((p) => (
            <Grid item xs={6} sm={3} key={p.NomProduit}>
              <Link
                to={`/InformationProduct/${p.NomProduit}`}
                style={{ textDecoration: "none" }}
              >
                <Box
                  sx={{
                    background: "white",
                    padding: "3px",
                    borderRadius: "16px",
                    ...stylebox,
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Box
                      component="img"
                      src={p.url_Image}
                      alt={p.NomProduit}
                      sx={{
                        borderTopLeftRadius: "20px",
                        borderTopRightRadius: "20px",

                        width: "100%",
                      }}
                    />
                  </div>

                  <Typography
                    sx={{
                      margin: "5px",
                      fontFamily: "F37 Ginger, sans-serif",
                      fontWeight: 400,
                      fontSize: "15px",
                      lineHeight: "20px",
                      letterSpacing: "0",
                      color: "#32324D",
                    }}
                  >
                    Tirage {p.NomProduit}
                  </Typography>
                </Box>
              </Link>
            </Grid>
          ))}
        </Grid>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept="image/*"
          multiple
          onChange={AddImage}
        />
      </Box>

      <BottomBar />
      <BackLoadingSimple open={loading} />
    </Box>
  );
}

export default InformationProduct;
